import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=05b15825&scoped=true&"
import script from "./GlobalLoader.vue?vue&type=script&lang=ts&"
export * from "./GlobalLoader.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=05b15825&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b15825",
  null
  
)

export default component.exports